import module_8737de3a7a104649ae9ebbd13fcce10f from 'nanogl-pbr/glsl/includes/glsl-compat.vert'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\n\n'+
(module_8737de3a7a104649ae9ebbd13fcce10f())+
'\n\nIN vec2 aPosition;\nOUT vec2 vTexCoord;\n\nuniform mat4 uMVP;\nuniform float uScale;\n\nvoid main(void){\n  gl_Position = uMVP * vec4(aPosition, 0.0, 1.0);\n  vTexCoord=  aPosition * uScale;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
